const files = require.context("@/api/module", true, /\.js$/); //搜索目录下所有js文件
const modules = {};
files.keys().forEach(key => {
  Object.assign(modules, files(key).default || files(key));
});

// console.log(modules);
export default modules;
